import { isEmpty } from 'lodash'

// Monta a referência de evidência no formato "[E2, p. 1, seção X]" usando a mesma
// numeração [En] da tabela "Evidências vinculadas" (evidence_map[path] → número).
const formatEvidenceReference = ({ path, location } = {}, evidenceMap = {}) => {
  const number = evidenceMap?.[path]
  const reference = number ? `E${number}` : null
  const parts = [reference, location].filter(Boolean)

  if (isEmpty(parts)) return null

  return `[${parts.join(', ')}]`
}

export default formatEvidenceReference
